export default __webpack_public_path__ + "static/media/flexsim-software-products-inc-logo.ff9419eb.svg";